module.exports = __webpack_public_path__ + "img/icon_britcoin.ddbc62d4.png";